import { lazy, Suspense } from "react";

// Defers recharts+d3 (~2MB raw) into an async chunk — same pattern as
// AsideStats.js (program-metrics). SSR renders nothing for this chart; it
// mounts after hydration.
const IncomeChartImpl = lazy(() =>
  import("./IncomeChart.impl").then((m) => ({ default: m.IncomeChart }))
);

const IncomeChart = (props) => (
  <Suspense fallback={null}>
    <IncomeChartImpl {...props} />
  </Suspense>
);

export default IncomeChart;
